import style from "./Property.module.css";
import Photo from "../UI/Photo";

function PropertyDisplayImgAddress({ property }) {
  return (
    <div className={"flex align-items-start"}>
      {property.main_photo_id ? (
        <Photo
          photoId={property.main_photo_id}
          type="property_photo"
          className={style.smallImage}
          alt="logement"
        />
      ) : property.type === "commercial" ? (
        <img
          src="/default-photo-commercial.jpeg"
          alt="logement"
          className={style.smallImage}
        />
      ) : (
        <img
          src="/default-photo-appartement.jpeg"
          alt="logement"
          className={style.smallImage}
        />
      )}
      <div className={"marginL10 marginB5"}>
        <p className={style.primaryText}>{property.nom}</p>
        {property.ville && (
          <>
            <p className={`marginT10 ${style.secondaryText2}`}>
              {property.rue}
              {property.complement_adresse && (
                <>
                  <br />
                  <span className={`${style.secondaryText2}`}>
                    {property.complement_adresse}
                  </span>
                  <br />
                </>
              )}
            </p>
            <p className={` ${style.secondaryText2}`}>
              {`${property.cp} ${property.ville}`}
            </p>
          </>
        )}
      </div>
    </div>
  );
}

export default PropertyDisplayImgAddress;
